import { Serializable } from '../../../core/models/serializable';
import { CustomerModel } from '../../../customers/shared/models/customer-model';
import { CvDatabaseAccessTokenRequestStatus } from '@admin/product-purchases/shared/models/cv-database-access-token-request-status';
import { CvDatabaseAccessTokenModel } from '@admin/product-purchases/shared/models/cv-database-access-token-model';

export class CvDatabaseAccessTokenRequestModel
  implements Serializable<CvDatabaseAccessTokenRequestModel>
{
  fromObject(obj: any): CvDatabaseAccessTokenRequestModel {
    Object.assign(this, obj);
    this.issuedTokens = [];
    if (
      obj.issuedTokens &&
      obj.issuedTokens.length &&
      obj.issuedTokens.length > 0
    ) {
      obj.issuedTokens.forEach((tokenObj) => {
        let t = new CvDatabaseAccessTokenModel();
        t = t.fromObject(tokenObj);
        this.issuedTokens.push(t);
      });
    }

    if (obj.requestCustomer != null) {
      let c = new CustomerModel();
      this.requestCustomer = c.fromObject(obj.requestCustomer);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public cvDatabaseAccessTokenRequestId: number;
  public requestUserId: number;
  public requestCustomerAgentId: number;
  public requestCustomerId: number;
  public requestCustomer: CustomerModel;
  public status: CvDatabaseAccessTokenRequestStatus;

  public approveUserId: number;
  public rejectUserId: number;
  public terminateUserId: number;

  public demoViewCountLimit: number;
  public TotalViewCountLimit: number;

  public processDate: Date;
  public rejectDate: Date;
  public terminateDate: Date;
  public createDate: Date;

  public expireDate: Date; //in the future each provider or provider groups wil have own product and thus own epxire date, so this field will be removed

  //public long OrderId { get; set; }//TODO: remove???

  public portfolioId: number;
  public portfolioName: string;
  public portfolioAccountManagerName: string;

  public issuedTokens: CvDatabaseAccessTokenModel[];

  public get customer() {
    return this.requestCustomer;
  }
}
